import { ICON_TYPES } from "./iconTypes";

// Function to convert frames to seconds - adjust FPS as needed
function framesToSeconds(frames, fps = 30) {
  return frames / fps;
}

export function parseIconPositions(csvData, routeIndex, timeframe) {
  const lines = csvData.split(/\r?\n/);
  if (lines.length < 2) return [];

  // 创建一个新的数组，而不是使用 reduce 的初始值
  const iconPositions = [];
  
  lines.slice(1).forEach((line) => {
    // Support more fields: type,latitude,longitude,title,image_path,frame_start,frame_end
    const parts = line.split(",").map((x) => x.trim());

    const typeStr = parts[0];
    const latStr = parts[1];
    const lngStr = parts[2];
    const popupText = parts[3] || `Icon ${typeStr.toLowerCase()} ${iconPositions.length + 1}`;
    const popupImage = parts[4] || "";
    
    // Extract frame_start and frame_end values
    const frameStart = parts[5] ? parseInt(parts[5], 10) : 0;
    const frameEnd = parts[6] ? parseInt(parts[6], 10) : 0;
    
    // Convert frames to seconds for video seeking
    const startTimeSeconds = framesToSeconds(frameStart);
    const endTimeSeconds = framesToSeconds(frameEnd);
    
    console.log(`Converting frames to seconds: ${frameStart} frames → ${startTimeSeconds.toFixed(2)} seconds`);
    
    const eventId = iconPositions.length;

    const lat = parseFloat(latStr);
    const lng = parseFloat(lngStr);
    const type = typeStr.toLowerCase();

    if (
      !isNaN(lat) &&
      !isNaN(lng) &&
      Object.values(ICON_TYPES).includes(type)
    ) {
      const robotId = routeIndex + 1;
      
      iconPositions.push({
        id: `icon_${routeIndex}_${iconPositions.length + 1}`,
        type,
        position: [lat, lng],
        popup: popupText,
        popupImage: popupImage,
        routeIndex,
        // Add event data for click navigation
        eventData: {
          robotId: robotId,
          eventId: eventId,
          startTime: startTimeSeconds, // Use converted seconds for video seeking
          endTime: endTimeSeconds,
          frameStart: frameStart,     // Keep original frame numbers for reference
          frameEnd: frameEnd,
          timeframe: timeframe
        }
      });
    }
  });

  return iconPositions;
}

export async function loadIconPositions(csvFilePath, routeIndex, timeframe = "11AM") {
  try {
    // Choose correct file path based on timeframe
    let adjustedPath = csvFilePath;
    const isDay = timeframe === "11AM";
    
    // Build path based on timeframe
    if (isDay) {
      if (!adjustedPath.includes("/day/map/iconmap/")) {
        adjustedPath = adjustedPath.replace('/icons_route', '/day/map/iconmap/icons_route');
      }
    } else {
      if (!adjustedPath.includes("/night/map/iconmap/")) {
        adjustedPath = adjustedPath.replace('/icons_route', '/night/map/iconmap/icons_route');
      }
    }
    
    console.log(`Loading icons from: ${adjustedPath} (timeframe: ${timeframe})`);
    
    const response = await fetch(adjustedPath);
    const csvData = await response.text();
    return parseIconPositions(csvData, routeIndex, timeframe);
  } catch (error) {
    console.error(`Error loading CSV file ${csvFilePath} for timeframe ${timeframe}:`, error);
    return [];
  }
}